import { createApp } from 'vue'
import LoginOverlay from './LoginOverlay'
import handleComponentProps from '../../foundation/js/utils/handleComponentProps'

const el = '.nyk-component--login-overlay'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((loginOverlayDOM) => {
            const props = handleComponentProps(LoginOverlay, loginOverlayDOM) || {};
            // If running in component library/demo, force open
            if (loginOverlayDOM.dataset.forceOpen === 'true') {
                props.forceOpen = true;
            }
            const component = createApp(LoginOverlay, props).use(Store)
            component.mount(loginOverlayDOM)
        })
    }
}
